import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useStateContext } from '../../contexts/ContextProvider';

interface GroupContextGateProps {
    /** Rendu en vue groupe ; absent : redirection vers la liste groupe. */
    group?: ReactNode;
    /** Rendu en vue hôtel ; absent : redirection vers la liste. */
    hotel?: ReactNode;
}

// Les pages Sociétés existent en deux versions : hôtel (lecture/écriture) et groupe (lecture seule).
// Une page qui n'existe que d'un côté renvoie vers la liste de l'autre.
export default function GroupContextGate({ group, hotel }: GroupContextGateProps) {
    const { currentFacility } = useStateContext();
    const content = currentFacility?.is_group ? group : hotel;
    return content ? <>{content}</> : <Navigate to="/companies" replace />;
}
